import styled from 'styled-components';

import { breakpoints, colors } from '@soluto-private/mx-asurion-ui-react';

import { SubContainers } from './SubContainers';

export const PageContainer = styled.div`
  max-width: 1440px;
  margin: auto;
  display: flex;
  flex-direction: column;

  ${breakpoints.md} {
    flex-direction: row;
    height: calc(100vh - var(--pageLayoutTopOffset, 80px));
  }
`;

export const LeftSectionContainer = styled.div`
  border-bottom: 1px solid ${colors.neutralBrighter};
  border-right: none;

  ${breakpoints.md} {
    flex: 1;
    border-bottom: none;
    border-right: 1px solid ${colors.neutralBrighter};
  }
`;

export const MainContentContainer = styled(SubContainers)`
  border-bottom: 1px solid ${colors.neutralBrighter};
  border-right: none;

  ${breakpoints.md} {
    flex: 1;
    border-bottom: none;
    border-right: 1px solid ${colors.neutralBrighter};
  }
`;

export const LeftMainNavigationButtonContainer = styled.div`
  height: 80px;
  padding: 16px;
  border-top: none;

  ${breakpoints.md} {
    height: 112px;
    border-top: 1px solid ${colors.neutralBrighter};
  }

  @media (max-width: 768px) {
    position: fixed;
    bottom: 0;
    display: flex;
    justify-content: space-between;
    width: calc(100% - 32px);
    align-items: center;
  }
`;
